'use client';

import { Book, ProductAddedSource, Title } from 'types';
import { Box } from '@/components/layout/box';
import AddToCartButton from '@/components/product/add-to-cart-button';
import BuyitNowButton from '@/components/product/buy-it-now-button';
import ExpressCheckoutPlugin from '@/components/checkout-components/express-checkout-plugin';
import { useState } from 'react';

interface ProductActionsClientProps {
  bookData?: Book & { sold?: boolean; };
  titleData?: Title;
  productAddedSource: ProductAddedSource;
}
export default function ProductActionsClient({ bookData, titleData, productAddedSource }: ProductActionsClientProps) {
  const [expressPaymentAvailable, setExpressPaymentAvailable] = useState(false);

  return (
    <Box mt={1} mb={1}>
      <Box mb={0.5}>
        <AddToCartButton
          book={bookData}
          source={productAddedSource}
          disabled={bookData?.sold || !bookData}
          selectedListing={titleData?.selected_listing?.id === bookData?.id}
        />
      </Box>
      <Box style={{ display: expressPaymentAvailable ? 'block' : 'none' }}>
        <ExpressCheckoutPlugin
          bookIds={[bookData?.id].filter(Boolean)}
          setExpressPaymentAvailable={setExpressPaymentAvailable}
        />
      </Box>
      <Box style={{ display: expressPaymentAvailable ? 'none' : 'block' }}>
        <BuyitNowButton
          book={bookData}
          source={productAddedSource}
          disabled={bookData?.sold || !bookData}
        />
      </Box>
    </Box >
  );
}